import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    choosedAddress: "", //从购物车到商品下单页选中的地址
    orderId: "",
    buyList: "", //立即购买的商品
    shopCarNum: 0, //购物车数量
    collectNum: 0,//收藏夹数量
    buyGoodsIds: [], //购物车结算的购物车商品id
    beforePage: {},//面包屑记录上一页的路由
  },
  plugins: [
    createPersistedState({
      //默认保存至sessionStorage
      storage: window.sessionStorage
      // reducer(val) {
      //   //默认全部储存state
      //   return {
      //     // 只储存state中的assessmentData
      //     assessmentData: val.assessmentData
      //   }
      // }
    })
  ],
  mutations: {
    saveAddress(state, choosedAddress) {
      state.choosedAddress = choosedAddress;
    },
    saveOrderId(state, orderId) {
      state.orderId = orderId;
    },
    saveBuyList(state, buyList) {
      state.buyList = buyList;
    },
    saveCollectNum(state, collectNum) {
      state.collectNum = collectNum;
    },
    saveShopCarNum(state, shopCarNum) {
      state.shopCarNum = shopCarNum;
    },
    saveBuyGoodsIds(state, buyGoodsIds) {
      state.buyGoodsIds = buyGoodsIds;
    },
    savePage(state, beforePage) {
      state.beforePage = beforePage;
    },
  },
  actions: {}
});



// WEBPACK FOOTER //
// ./src/store.js